"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventType = void 0;
var EventType;
(function (EventType) {
    EventType["BESTFIT_OVERVIEW_READY"] = "BestfitOverviewReady";
    EventType["BESTFIT_RECALCULATED"] = "BestfitRecalculated";
    EventType["BESTFIT_MODIFY_ANSWER"] = "BestfitModifyAnswer";
})(EventType || (exports.EventType = EventType = {}));
